<template>
    <div class="flex justify-between w-full" :class="myMessage && 'flex-row-reverse'" :id="`message_${ messageItem.id }`">
        <div class="flex" :class="myMessage && 'flex-row-reverse'">
            <div :class="myMessage ? 'ml-3' : 'mr-3'" v-if="messageItem.author && !messageItem.is_deleted">
                <vs-avatar class="border-2 border-solid border-white m-0" v-if="messageItem.author.avatar" :src="messageItem.author.avatar" :size="windowWidth > 986 ? '42px' : '32px'" />
                <vs-avatar class="border-2 border-solid border-white m-0" v-else :text="avatarText" :size="windowWidth > 986 ? '42px' : '32px'" />
            </div>
            <div :class="['msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm', messageBg, isDelete, textLength && 'large_message', expand && 'show']">
                <div class="user_name text-xs placeholder-opacity-80 flex item-center">
                    {{messageItem.author ? messageItem.author.full_name : this.$t('systemic')}}
                    <template v-if="!messageItem.is_system">
                        {{messageItem.author.profileId === openDialog.author.profileId ? ` - ${$t('owner')}` : ''}}
                        <!--{{(message.author.id !== openDialog.author.id && openDialog.is_moderator) ? ' - Модератор' : ''}}-->
                    </template>
                    <feather-icon
                        v-if="deleteBtnShow"
                        class="cursor-pointer ml-2"
                        @click="deleteMessage()"
                        style="float:right;"
                        svgClasses="w-4 h-4"
                        icon="XIcon" />
                </div>
                <div class="reply_message cursor-pointer mt-2 mb-2 pt-1 pb-1 pr-2" v-if="messageItem.message_reply && !messageItem.is_deleted" @click="replySearch(messageItem.message_reply)">
                    <div class="reply_author text-xs">
                        {{messageItem.message_reply.author.full_name}}
                        {{messageItem.message_reply.author.profileId === openDialog.author.profileId ? ` - ${$t('owner')}` : ''}}
                    </div>
                    <div class="reply_text mt-1 text-sm" v-if="messageItem.message_reply.text.length" v-html="messageItem.message_reply.text"></div>
                    <div v-else class="mt-1 text-sm"><feather-icon icon="FileIcon" svgClasses="w-3 h-3" /> {{$t('file_image')}}</div>
                </div>
                <div class="message" v-html="textReplace"></div>
                <div class="cursor-pointer mt-3 text-sm" @click="toggleShow()" v-if="textLength">{{expandText}}</div>

                <ChatMessageFiles v-if="messageItem.attachments.length && !messageItem.is_deleted" :message="messageItem" />

                <div class="mt-2 text-xs flex item-center">
                    <div v-if="!messageItem.is_deleted && !messageItem.is_system" class="cursor-pointer mr-4" @click="replyMethod(messageItem)">
                        <span class="flex item-center">
                            <feather-icon
                                class="mr-1"
                                svgClasses="w-3 h-3"
                                icon="CornerDownRightIcon" />
                            {{$t('to_answer')}}
                        </span>
                    </div>
                    <div class="flex item-center">
                        <feather-icon
                            svgClasses="w-3 h-3"
                            class="mr-1"
                            icon="ClockIcon" />
                        {{date}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChatMessageFiles from './ChatMessageFiles'
import {mapState} from 'vuex'
export default {
    props: {
        messageItem: {
            type: Object,
            require: true
        },
        user: {
            type: Object,
            required: true
        },
        replyMethod: {
            type: Function,
            required: true
        },
        replySearch: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            expand: false,
            expandText: this.$t('uncover')
        }
    },
    methods: {
        toggleShow() {
            if(this.expand) {
                this.expand = false
                this.expandText = this.$t('uncover')
            } else {
                this.expand = true
                this.expandText = this.$t('collapse')
            }
        },
        async deleteMessage() {
            try {
                await this.$store.dispatch('chat/deleteMessage', this.messageItem)
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'success'
                })
            }
        }
    },
    computed: {
        ...mapState({
            openDialog: state => state.chat.openDialog,
            windowWidth () { return this.$store.state.windowWidth },
        }),
        deleteBtnShow() {
            if(!this.messageItem.is_system && !this.messageItem.is_deleted && this.messageItem.author && this.user.profileId === this.messageItem.author.profileId
            || !this.messageItem.is_system && !this.messageItem.is_deleted && this.openDialog.is_public && this.openDialog.is_moderator && this.openDialog.author.profileId !== this.messageItem.author.profileId) {

                const messDate = this.$moment().add(1, 'minutes').format()
                if(this.$moment(messDate).diff(this.messageItem.created, 'minutes') <= 1)
                    return true
                else
                    return false
            } else
                return false
        },
        textLength() {
            if(this.messageItem.text.length > 300)
                return true
        },
        textReplace() {
            const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

            let t = this.messageItem.is_system || this.messageItem.is_deleted ? this.messageItem['text_'+ this.$i18n.locale] : this.messageItem.text
            return t.replace(urlRegex, (url) => {
                return '<a target="_blank" href="' + url + '">' + url + '</a>';
            })
        },
        date() {
            return this.$moment(this.messageItem.created).format('HH:mm')
        },
        isDelete() {
            if(this.messageItem.is_deleted)
                return 'delete_message'
        },
        messageBg() {
            if(this.messageItem.author) {
                if(this.user.profileId === this.messageItem.author.profileId)
                    return 'bg_primary text-white'
                else
                    return 'border border-solid border-transparent bg_white'
            } else
                return 'delete_message'
        },
        myMessage() {
            if(this.messageItem.author)
                if(this.user.profileId === this.messageItem.author.profileId)
                    return true
        },
        avatarText() {
            if(this.messageItem.author.full_name) {
                // Возвращяем инициалы пользователя
                let title,
                    text = this.messageItem.author.full_name
                const textAr = text.split(' ')
                if (textAr.length) {
                    const newTitle = []
                    textAr.forEach(item => {
                        newTitle.push(item.substr(0, 1).toUpperCase())
                    })
                    title = newTitle.join('')
                } else title = text.substr(0, 1)
                return title
            }
        }
    },
    components: {
        ChatMessageFiles
    }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 693px) {
    .reply_text{
        max-width: 240px;
    }
}
@media only screen and (max-width: 325px) {
    .reply_text{
        max-width: 180px;
    }
}
.message{
    word-break: break-word;
}
</style>

<style lang="scss">
.message{
    audio{
        width: 100%;
    }
}
.reply_message{
    border-left: 2px solid;
    border-radius: 0px 5px 5px 0px;
    padding-left: 5px;
    .reply_text{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
.delete_message{
    background-color: #a49df3 !important;
    color: #ffffff!important;
}
.large_message{
    &:not(.show){
        .message{
            position: relative;
            max-height: 80px;
            overflow: hidden;
            &::after{
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 60px;
                z-index: 5;
            }
        }
    }
}
.bg_primary{
    background-color: rgba(var(--vs-primary), 1);
    .reply_message{
        background: rgba(0, 0, 0, 0.1);
        border-color: #fff;
    }
    .message{
        a{
            color: #fff;
        }
    }
    &.large_message{
        &:not(.show) {
            .message{
                &::after{
                    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,545da7+100&0+0,1+100 */
                    background: -moz-linear-gradient(top,  rgba(255,255,255,0) 0%, rgba(84,93,167,1) 100%); /* FF3.6-15 */
                    background: -webkit-linear-gradient(top,  rgba(255,255,255,0) 0%,rgba(84,93,167,1) 100%); /* Chrome10-25,Safari5.1-6 */
                    background: linear-gradient(to bottom,  rgba(255,255,255,0) 0%,rgba(84,93,167,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#545da7',GradientType=0 ); /* IE6-9 */
                }
            }
        }
    }
}
.bg_white{
    background-color: #ffffff;
    .reply_message{
        background: rgba(0, 0, 0, 0.05);
        border-color: #a49df3;
    }
    &.large_message{
        &:not(.show) {
            .message{
                &::after{
                    /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,ffffff+100&0+0,1+99 */
                    background: -moz-linear-gradient(top,  rgba(255,255,255,0) 0%, rgba(255,255,255,1) 99%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
                    background: -webkit-linear-gradient(top,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 99%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
                    background: linear-gradient(to bottom,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 99%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
                    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
                }
            }
        }
    }
}
.msg{
    transition: opacity 0.4s ease-in-out;
    opacity: 1;
    .message{
        a{
            border-bottom: 1px solid;
        }
    }
}
.flashing{
    .msg{
        opacity: 0.4;
    }
}
</style>
